export const PLAYMARKET_URL = 'https://play.google.com/store/apps/details?id=com.evotorapp'
export const APPSTORE_URL = 'https://apps.apple.com/app/id1477548635'
export const RustoreUrl = 'https://apps.rustore.ru/app/com.evotorapp'
export const HuaweiStoreUrl = 'https://url.cloud.huawei.com/kj1vB60ueA?shareTo=qrcode'
export const DEEPLINK_AUTH = 'tradestat://auth/'